module.exports = __webpack_public_path__ + "static/img/kdlogo.f09b4d97.png";